export default class CountryLanguageWriteDTO {

    public id: number | undefined;
    public countryId: number | undefined;
    public languageId: number | undefined;

    constructor(data: { [key: string]: any }) {
        this.countryId = data['countryId'] || undefined;
        this.languageId = data['languageId'] || undefined;
    }
}